export const LOADER = "loader";